import { useMemo } from 'react';

import { isHexDark, randomHexFromString } from '../../../../utils/color';

export const useAvatarWithRandomColor = (fallback: string) => {
  const bg = useMemo(() => randomHexFromString(fallback), [fallback]);
  const isBgDark = useMemo(() => isHexDark(bg), [bg]);
  // bg is not light/dark mode-aware, so we _need_ to hardcode the colour number, not a semantic colour token
  const color = useMemo(() => (isBgDark ? 'white' : 'gray.800'), [isBgDark]);

  return {
    bg,
    color,
  };
};
